import * as React from 'react'
import styled, { css } from 'styled-components'
import { Slide } from 'react-reveal'

import DashboardLayout from '../../../../components/ui/DashboardLayout/DashboardLayout'
import CardSlider from '../../../../components/home/CardSlider/CardSlider'
import FeaturedCard from '../../../../components/home/FeaturedCard/FeaturedCard'
import Icon from '../../../../components/ui/Icon/Icon'

import CardListModal from '../../../../components/ui/CardListModal/CardListModal'
import ArticleCard from '../../../../components/ui/ArticleCard/ArticleCard'

import formatDisplaySchedule from '../../../../services/schedule/formatDisplaySchedule'
import media from '../../../../services/generateMediaQueries'
import getMarketingContentLabel from '../../../../services/data/getMarketingContentLabel'
import AwakenAmazing from '../../../../assets/img/awaken-amazing.png'

const Header = styled.div`
  position: fixed;
  min-height: 5rem;
  width: 100%;
  z-index: 10000;
`

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 100px;
  min-height: 400px;

  ${media.lessThan('medium')`
    margin-bottom: 1.25rem;
    min-height: 520px;
  `}
`

const ButtonNavWrapper = styled.div`
  position: absolute;
  top: calc(200px - (52px / 2));
  right: 6rem;

  ${props =>
    props.left &&
    css`
      right: unset;
      left: 6rem;
    `}

  ${media.lessThan('large')`
    right: 2rem;

    ${props =>
      props.left &&
      css`
        right: unset;
        left: 2rem;
      `}
  `}

  ${media.lessThan('medium')`
    display: none;
  `}
`

const ButtonNav = styled.button`
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  outline: none;
  margin-right: 0.5rem;
  border: 1px solid var(--color-fg-lighter);
  font-size: 1.8rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-fg-lighter);
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  & > svg {
    margin-top: -5px;
    margin-left: ${props => (props.right ? 0 : '-5px')};
    margin-right: ${props => (props.right ? '-5px' : 0)};
  }

  :last-child {
    margin-right: 0;
  }

  :hover {
    background: var(--color-primary);
    border-color: transparent;
    color: white;
    transition: all var(--animation-duration) var(--animation-easing);
  }

  :focus {
    border-color: var(--color-primary);
    transition: all var(--animation-duration) var(--animation-easing);
  }
`

const BannerTitle = styled.img.attrs({ src: AwakenAmazing })`
  max-height: 186px;

  ${media.lessThan('medium')`
    padding: 0 3rem;
  `}
`

class BannerWithFeatured extends React.Component {
  featuredSlider = React.createRef()

  featuredSliderNext = () => {
    this.featuredSlider.current.slickNext()
  }

  featuredSliderPrev = () => {
    this.featuredSlider.current.slickPrev()
  }

  render() {
    const {
      heroBannerPreview = {},
      featuredPreview = {},
      listViewPreview = {},
      bannerLayout = 0,
    } = this.props
    const featuredData = featuredPreview || {}
    const listViewData = listViewPreview || {}

    return (
      <>
        <Header />
        <DashboardLayout
          heroBannerData={{ ...heroBannerPreview, layout: bannerLayout }}
          heroBannerTitle={<BannerTitle />}
          hasFooter={false}
          previewMode
        >
          <Wrapper>
            <Slide right>
              <CardSlider
                dataSource={Array.from(Array(3))}
                renderItem={(item = {}, index) => (
                  <FeaturedCard
                    key={index}
                    id={index}
                    schedule={formatDisplaySchedule(
                      featuredData.schedule || '',
                    )}
                    featuredImgUrl={featuredData.logoUrl || ''}
                    bannerImgUrl={featuredData.imageUrl || ''}
                    title={featuredData.title || ''}
                    body={featuredData.body || ''}
                    onClick={e => e.preventDefault()}
                    label={getMarketingContentLabel(item).name}
                    // label={featuredData.customLabel}
                  />
                )}
                ref={this.featuredSlider}
                featured
              />
            </Slide>

            <ButtonNavWrapper left>
              <ButtonNav onClick={this.featuredSliderPrev}>
                <Icon name="slide-left" />
              </ButtonNav>
            </ButtonNavWrapper>

            <ButtonNavWrapper>
              <ButtonNav onClick={this.featuredSliderNext} right>
                <Icon name="slide-right" />
              </ButtonNav>
            </ButtonNavWrapper>
          </Wrapper>
          <CardListModal
            show={!!listViewPreview}
            onClose={this.handleClose}
            title="List Title"
            description="List Description"
            source={Array.from(Array(3))}
            render={(item, index) => (
              <ArticleCard
                key={index}
                imageUrl={listViewData.imageUrl}
                logoUrl={listViewData.logoUrl}
                title={listViewData.title}
                schedule={formatDisplaySchedule(listViewData.schedule || '')}
                /* eslint-disable-line no-script-url */
                link={'javascript:void(0)'}
                isDisabled
              />
            )}
          />
        </DashboardLayout>
      </>
    )
  }
}

BannerWithFeatured.defaultProps = {
  // TODO: specify default props
}

BannerWithFeatured.propTypes = {
  // TODO: specify prop types
}

export default BannerWithFeatured
